<template>
  <div class="container">
    <!-- <div class="iconbtn">
      <a href>关于我们</a>
      <a href>服务内容</a>
      <a href>超级案例</a>
      <a href>行业解决方案</a>
    </div> -->
    <div class="banner" style="background-color:#243E9F">
      <el-carousel trigger="click" height="700px" indicator-position="none">
        <el-carousel-item
          v-for="item in 2"
          :key="item"
          style="display: flex;
          justify-content: center;
          align-items: center;"
        >
          <div v-if="item == 1">
            <img src="../assets/img/bg1.png" alt />
          </div>
          <div v-if="item == 2">
            <img src="../assets/img/bg2.png" alt />
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="AboutUs" id="aboutus">
      <div class="abBox">
        <div class="btn-box-bg">
          <button class="left" @click="bigPrev()">←</button>
          <button class="right" @click="bigNext()">→</button>
        </div>
        <div class="Indicator">
          <span :class="{ activespan: tag == 1 }" @click="tag = 1">01</span>
          <span :class="{ activespan: tag == 2 }" @click="tag = 2">02</span>
          <span :class="{ activespan: tag == 3 }" @click="tag = 3">03</span>
        </div>
        <div class="title" id="a" ref="a">
          <h1>
            关于我们
            <br />BUSINESS INTRO
          </h1>
          <img src="../assets/img/fangkuai.png" alt />
        </div>
        <div class="OuterBanner" v-if="tag == 1" v-show="tag == 1">
          <div class="img-box beforeBox1 beforeBox2">
            <img :src="imgsrc[index]" alt />
            <div class="btn-box">
              <button @click="smallPrev">&lt;</button>
              <button @click="smallNext" style="margin-left:-5px">&gt;</button>
            </div>
          </div>
          <div class="text-box">
            <h1>
              思励格 成立于2009年
              <br />历经 <span>10 </span>余年沉淀
            </h1>
            <div class="line"></div>
            <div class="text-conter">
              我们是移动互联网和数字化产品设计专家和研发管专家，致力于数字产品策略咨询、创新设计和技术研发，通过数字化产品和服务，为政府和企业客户提供从策略到落地系统型的价值创新。
            </div>
            <p style="letter-spacing:2px">移动互联及数字化产品解决方案服务商</p>
          </div>
        </div>
        <div class="OuterBanner" v-if="tag == 2" v-show="tag == 2">
          <div class="img-box logoBox">
            <a href v-for="item in icons" :key="item.id">
              <img :src="item.iconsrc" alt />
              <p class="icon-p">{{ item.name }}</p>
            </a>
          </div>
          <div class="text-box">
            <h1>
              我们在
              <br />解决什么问题?
            </h1>
            <div class="line"></div>
            <div class="text-conter">
              帮助客户构建安全、可视化、体验好的数字化产品及智能化系统解决方案
              <br />帮助企业构建增长和利润引擎
            </div>
            <p style="letter-spacing:2px">
              客户在互联网及数字化创新道路上有太多杂乱的问题， 95%以上的
              <br />中国企业无法独立解决。
            </p>
          </div>
        </div>
        <div class="OuterBanner" v-if="tag == 3" v-show="tag == 3">
          <div class="img-box Scheme">
            <img src="../assets/img/jiejue2x.png" alt />
          </div>
          <div class="text-box">
            <h1>
              我们的
              <br />解决方案是...
            </h1>
            <div class="line"></div>
            <div class="text-conter">
              以客户问题为中心,提供数字产品从
              <span style="color:white;">战略制定</span>到
              <span style="color:white;">策略研究</span>到
              <span style="color:white;">落地实施</span>的完整解决方案
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="Service">
      <div class="seBox">
        <div class="title">
          <h1>
            服务内容
            <br />SERVICE CONTENT
          </h1>
          <img src="../assets/img/fangkuai.png" alt />
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick" :stretch="true">
          <el-tab-pane label="产品咨询与设计服务" name="first">
            <div class="ads">
              <div class="itemBox">
                <div class="icon-box">
                  <img src="../assets/img/1.png" alt />
                  <p>F.01</p>
                </div>
                <div class="text-box">
                  <h1>
                    ZERO TO ONE
                    <br />产品从零到一
                  </h1>
                  <p>
                    了解项目背景,定义核心问题
                    <br />寻找机会点
                  </p>
                </div>
              </div>
              <div class="itemBox">
                <div class="icon-box">
                  <img src="../assets/img/2.png" alt />
                  <p>F.02</p>
                </div>
                <div class="text-box">
                  <h1>
                    DIGIALIZATION
                    <br />业务数字化
                  </h1>
                  <p>
                    制定商业战略、构思解决方案
                    <br />落地创新概念
                  </p>
                </div>
              </div>
              <div class="itemBox">
                <div class="icon-box">
                  <img src="../assets/img/3.png" alt />
                  <p>F.03</p>
                </div>
                <div class="text-box">
                  <h1>
                    INNOVATION
                    <br />差异化创新
                  </h1>
                  <p>
                    我们帮助企业找到解决复杂问题的
                    <br />简单方式
                  </p>
                </div>
              </div>
              <div class="itemBox">
                <div class="icon-box">
                  <img src="../assets/img/4.png" alt />
                  <p>F.04</p>
                </div>
                <div class="text-box">
                  <h1>
                    GROWTH
                    <br />构建增长引擎
                  </h1>
                  <p>
                    我们帮助企业发现撬动业务发展的最高杠 杆 ·
                    我们帮助企业成为能够不断跨越数字 鸿沟的创新组织
                    <br />
                  </p>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="技术研发与运维管理" name="second">
            <div class="ads">
              <div class="itemBox">
                <div class="icon-box">
                  <img src="../assets/img/5.png" alt />
                  <p>F.01</p>
                </div>
                <div class="text-box">
                  <h1>
                    FRAMEWORK
                    <br />架构与实施
                  </h1>
                  <p>
                    云端管理、架构设计与搭建、服务器、数据库、安全等；支持公有云、专有云、混合云，提供全行业解决方案
                    了解项目背景,定义核心问题
                    <br />
                  </p>
                </div>
              </div>
              <div class="itemBox">
                <div class="icon-box">
                  <img src="../assets/img/6.png" alt />
                  <p>F.02</p>
                </div>
                <div class="text-box">
                  <h1>
                    PRODUCT
                    <br />产品与开发
                  </h1>
                  <p>
                    企业VI视觉设计、一站式建站、电商平台应用级业务系统定制开发；覆盖
                    PC、Web、App、微信公众号、小程序、游戏开发
                    <br />
                  </p>
                </div>
              </div>
              <div class="itemBox">
                <div class="icon-box">
                  <img src="../assets/img/7.png" alt />
                  <p>F.03</p>
                </div>
                <div class="text-box">
                  <h1>
                    INTEGRATION
                    <br />系统与集成
                  </h1>
                  <p>
                    OA、HR、CRM、ERP、财务管理会员管理、订单管理、即时通讯大数据分析、可视化、系统集成
                    <br />
                  </p>
                </div>
              </div>
              <div class="itemBox">
                <div class="icon-box">
                  <img src="../assets/img/8.png" alt />
                  <p>F.04</p>
                </div>
                <div class="text-box">
                  <h1>
                    OPERATION
                    <br />运营与维护
                  </h1>
                  <p>
                    多维测试、人员驻场、网络安全内容制作、培训课件、推广渠道运营策划
                    <br />
                  </p>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="项目交付与安全保障" name="third">
            <div class="bds">
              <div class="itemBox">
                <div class="icon-box">
                  <img src="../assets/img/9.png" alt />
                  <p>F.01</p>
                </div>
                <div class="text-box">
                  <h1>
                    GUARANTEE
                    <br />双线保障服务制
                  </h1>
                  <p>
                    一名项目经理 ，一名质量交付经理
                    ，双线监督项目进度，严格控项目质量，给研发进程保驾护航
                  </p>
                </div>
              </div>
              <div class="itemBox">
                <div class="icon-box">
                  <img src="../assets/img/10.png" alt />
                  <p>F.02</p>
                </div>
                <div class="text-box">
                  <h1>
                    CORE
                    <br />6项核心管理
                  </h1>
                  <p>计划、需求、 风险、质量、变更、资源，六项精细管管理</p>
                </div>
              </div>
              <div class="itemBox">
                <div class="icon-box">
                  <img src="../assets/img/11.png" alt />
                  <p>F.03</p>
                </div>
                <div class="text-box">
                  <h1>
                    QUALITY
                    <br />7道质量门槛
                  </h1>
                  <p>
                    产品逻辑、UI体验、研发架构、 日常代码部署、
                    里程碑校验、测试验收、交付上线，七道质量门 ， 不过不关
                  </p>
                </div>
              </div>
              <div class="itemBox">
                <div class="icon-box">
                  <img src="../assets/img/12.png" alt />
                  <p>F.04</p>
                </div>
                <div class="text-box">
                  <h1>
                    STANDARD
                    <br />大厂级代码标准
                  </h1>
                  <p>
                    高可用前后分离代码标准，全API接 ，降低开发成本，符合国际标准
                  </p>
                </div>
              </div>
              <div class="itemBox">
                <div class="icon-box">
                  <img src="../assets/img/5.png" alt />
                  <p>F.05</p>
                </div>
                <div class="text-box">
                  <h1>
                    FILE
                    <br />详细规范化文档
                  </h1>
                  <p>
                    完整的全流程记录，详细规范的文化留存，可满足等保三级标准
                  </p>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="superCase">
      <div class="suBox">
        <div class="Indicatortwo">
          <span :class="{ activespantwo: tag == 1 }" @click="tag = 1">01</span>
          <span :class="{ activespantwo: tag == 2 }" @click="tag = 2">02</span>
        </div>
        <div class="title">
          <h1>
            每年深度服务两个超级案例
            <br />SUPER CASE
          </h1>
          <img src="../assets/img/fangkuai.png" alt />
        </div>
        <div class="su-banner" v-if="tag == 1" v-show="tag == 1">
          <div class="item-banner">
            <div class="imgBox">
              <p class="imgBox-p"><span>TYPE:</span>ENTERPRISE</p>
              <img src="../assets/img/sulogo1.png" alt />
              <p class="imgBox-p">
                <span>合作时间：</span>
                <br />6年
              </p>
              <p class="imgBox-p psis">
                <span>配套服务：</span>
                <br />365天人员驻场运维、创新工作模式输出、敏捷团队搭建
              </p>
              <div class="btnBox">
                <p>READ MORE</p>
              </div>
              <div class="poBox" style="left:350px">
                <p class="poBox-p"><span>TYPE:</span>ENTERPRISE</p>
                <img src="../assets/img/sulogo1.png" alt />
                <p class="poBox-p">
                  <span>合作时间：</span>
                  <br />6年
                </p>
                <p class="poBox-p">
                  <span>配套服务：</span>
                  <br />365天人员驻场运维、创新工作模式输出、敏捷团队搭建
                  国际化政府机构如何安全、高效的进行数字化产品设计，与世界各组织共同携手共建网络空间命运共同体？
                  专业技术人员组成专项小组现场保障服务:
                  中外减贫案例库数据管理平台\扶贫电子书在线编辑平台\扶贫知识库在线分享平台\会议在线报名及服务平台\门户网站及内部OA系统
                </p>
              </div>
            </div>
            <div class="imgBox">
              <p class="imgBox-p"><span>TYPE:</span>GOVERNMENT</p>
              <img src="../assets/img/sulogo2.png" alt />
              <p class="imgBox-p">
                <span>合作时间：</span>
                <br />5年
              </p>
              <p class="imgBox-p psis">
                <span>配套服务：</span>
                <br />资深行业顾问深度参与企业项目运营、聚合支付平台
              </p>
              <div class="btnBox">
                <p>READ MORE</p>
              </div>
              <div class="poBox" style="right:350px;width:550px">
                <p class="poBox-p"><span>TYPE:</span>GOVERNMENT</p>
                <img src="../assets/img/sulogo2.png" alt />
                <p class="poBox-p">
                  <span>合作时间：</span>
                  <br />5年
                </p>
                <p class="poBox-p">
                  <span>配套服务：</span>
                  <br />传统企业，如何敏捷且高效的进行产品和服务创新，如何进行数字化转型增长？
                  资深行业顾问深度参与企业项目运营:
                  蜂彩宝电商平台\安证宝游戏服务平台
                  聚合支付平台\农产品健康生活服务平台
                </p>
              </div>
            </div>
            <div class="imgBox">
              <p class="imgBox-p"><span>TYPE:</span>INTERNET</p>
              <img src="../assets/img/sulogo3.png" alt />
              <p class="imgBox-p">
                <span>业务类型：</span>
                <br />基于物联网技术的彩票自助终端业务创新
              </p>
              <p class="imgBox-p psis">
                <span>配套服务：</span>
                <br />智能手机和人工智能的互动技术引爆了智能
                自助终端机的广泛应用，人脸识别技术有...
              </p>
              <div class="btnBox">
                <p>READ MORE</p>
              </div>
              <div class="poBox" style="right:350px">
                <p class="poBox-p"><span>TYPE:</span>GOVERNMENT</p>
                <img src="../assets/img/sulogo3.png" alt />
                <p class="poBox-p">
                  <span>业务类型：</span>
                  <br />基于物联网技术的彩票自助终端业务创新
                </p>
                <p class="poBox-p">
                  <span>配套服务：</span>
                  <br />智能手机和人工智能的互动技术引爆了智能自助终端机的广泛应用，人脸识别技术有效规避了未成年人消费场景，便捷小巧的智能设备突破了传统的实体店的单一渠道，积分系统的应用可将体育彩票与竞技赛事完美结合；用科技的力量“让体育创造快乐”
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="su-banner" v-if="tag == 2" v-show="tag == 2">
          <div class="item-banner">
            <div class="imgBox">
              <p class="imgBox-p"><span>TYPE:</span>BLOVCKCHAIN</p>
              <img src="../assets/img/gzmt.png" alt />
              <p class="imgBox-p">
                <span>服务类型：</span>
                <br />基于区块链技术的产品溯源
              </p>
              <p class="imgBox-p psis">
                <span>配套服务：</span>
                <br />基于区块链技术的研究, 利用其去中心化、信
                息透明、公开、可溯源、难篡改等特性
              </p>
              <div class="btnBox">
                <p>READ MORE</p>
              </div>
              <div class="poBox" style="left:350px">
                <p class="poBox-p"><span>TYPE:</span>BLOVCKCHAIN</p>
                <img src="../assets/img/gzmt.png" alt />
                <p class="poBox-p">
                  <span>服务类型：</span>
                  <br />基于区块链技术的产品溯源
                </p>
                <p class="poBox-p">
                  <span>配套服务：</span>
                  <br />基于区块链技术的研究,
                  利用其去中心化、信息透明、公开、可溯源、难篡改等特性,
                  构建茅台酱香酒的产品溯源模式,进而有效抵制“假身份”的茅台酒流入到人们生活中,
                  使购买该商品的消费者权益得到保障,
                  从而有效解决茅台酒的溯源防伪问题。
                </p>
              </div>
            </div>
            <div class="imgBox">
              <p class="imgBox-p">
                <span>TYPE:</span>
                SERVICE
              </p>
              <img src="../assets/img/beij.png" alt />
              <p class="imgBox-p">
                <span>业务类型：</span>
                <br />从零到一的教育机构品牌建设与服务设计
              </p>
              <p class="imgBox-p psis">
                <span>配套服务：</span>
                <br />国际教育品牌落地中国前期调研、教育机
                构实体空间运营及招生策划、学员信
              </p>
              <div class="btnBox">
                <p>READ MORE</p>
              </div>
              <div class="poBox" style="right:350px;width:550px;">
                <p class="poBox-p"><span>TYPE:</span>GOVERNMENT</p>
                <img src="../assets/img/beij.png" alt />
                <p class="poBox-p">
                  <span>业务类型：</span>
                  <br />从零到一的教育机构品牌建设与服务设计
                </p>
                <p class="poBox-p">
                  <span>配套服务：</span>
                  <br />国际教育品牌落地中国前期调研、教育机构实体空间运营及招生策划、学员信息化管理及数字平台搭建
                </p>
              </div>
            </div>
            <div class="imgBox">
              <p class="imgBox-p">
                <span>TYPE:</span>
                DIGITIZATION
              </p>
              <img src="../assets/img/yjx.png" alt />
              <p class="imgBox-p">
                <span>业务类型：</span>
                <br />用数字化定义未来基层优质社区连锁诊所
              </p>
              <p class="imgBox-p psis">
                <span>配套服务：</span>
                <br />社区慢病及养老服务场景洞察源自美国JCI服
                务体系架构搭建、连锁诊所服务全数字化...
              </p>
              <div class="btnBox">
                <p>READ MORE</p>
              </div>
              <div class="poBox" style="right:350px">
                <p class="poBox-p"><span>TYPE:</span>DIGITIZATION</p>
                <img src="../assets/img/yjx.png" alt />
                <p class="poBox-p">
                  <span>业务类型：</span>
                  <br />用数字化定义未来基层优质社区连锁诊所
                </p>
                <p class="poBox-p">
                  <span>配套服务：</span>
                  <br />社区慢病及养老服务场景洞察、源自美国JCI服务体系架构搭建、还有连锁诊所服务全数字化流程
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="next">
          <div @click="subigPrev()">←</div>
          <div @click="subigNext()">→</div>
        </div>
      </div>
    </div>
    <div class="industry">
      <div class="inBox">
        <div class="title">
          <h1>
            行业解决方案
            <br />INDUSTRY SOLUTIONS
          </h1>
          <img src="../assets/img/fangkuai.png" alt />
        </div>
      </div>
      <div class="block">
        <div class="Modul">
          <router-link to="./caseszx">
            <div>
              <img src="../assets/img/07.png" alt />
            </div>
            <p>在线教育</p>
          </router-link>
          <router-link to="./casesds">
            <div>
              <img src="../assets/img/01.png" alt />
            </div>
            <p>电商新零售</p>
          </router-link>
          <router-link to="./caseszf">
            <div>
              <img src="../assets/img/02.png" alt />
            </div>
            <p>政府案例</p>
          </router-link>
          <router-link to="./caseswy">
            <div>
              <img src="../assets/img/03.png" alt />
            </div>
            <p>文化娱乐</p>
          </router-link>
          <router-link to="./casestc">
            <div>
              <img src="../assets/img/04.png" alt />
            </div>
            <p>体彩竞技</p>
          </router-link>
          <router-link to="./casesyl">
            <div>
              <img src="../assets/img/05.png" alt />
            </div>
            <p>医疗健康</p>
          </router-link>
          <router-link to="./caseshl">
            <div>
              <img src="../assets/img/06.png" alt />
            </div>
            <p>互联网金融</p>
          </router-link>
        </div>
      </div>
    </div>
    <div class="Partners">
      <div>
        <a href v-for="item in Partners" :key="item.id">
          <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
            <line class="top" x1="0" y1="0" x2="810" y2="0" />
            <line class="left" x1="0" y1="164" x2="0" y2="-328" />
            <line class="bottom" x1="270" y1="164" x2="-540" y2="164" />
            <line class="right" x1="270" y1="0" x2="270" y2="492" />
          </svg>
          <img :src="item.Partnersrc" alt />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../utils/axios";
import VueScrollTo from "vue-scrollto";
import Vue from "vue";
Vue.use(VueScrollTo, options);
let options = {
  container: "body", //滚动的容器
  duration: 500, //滚动时间
  easing: "ease", //缓动类型
  offset: 0, //滚动时应应用的偏移量。此选项接受回调函数
  force: true, //是否应执行滚动
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
};
export default {
  data() {
    return {
      activeName: "first",
      show: false,
      tag: 1,
      imgsrc: [require("@/assets/img/qh.png"), require("@/assets/img/qh1.png")],
      index: 0,
      currentIndex: 0,
      Xvalue: 0,
      icons: [
        { name: "新项目孵化", iconsrc: require("@/assets/img/icon01.png") },
        { name: "聚合支付平台", iconsrc: require("@/assets/img/icon02.png") },
        { name: "大数据应用", iconsrc: require("@/assets/img/icon03.png") },
        { name: "行业咨询", iconsrc: require("@/assets/img/icon04.png") },
        { name: "文娱互动直播", iconsrc: require("@/assets/img/icon05.png") },
        { name: "企业官网建设", iconsrc: require("@/assets/img/icon06.png") },
        { name: "企业效率工具", iconsrc: require("@/assets/img/icon07.png") },
        { name: "信息系统建设", iconsrc: require("@/assets/img/icon08.png") },
        { name: "微信小程序开发", iconsrc: require("@/assets/img/icon09.png") },
        { name: "移动端app开发", iconsrc: require("@/assets/img/icon10.png") },
        { name: "品牌VIS", iconsrc: require("@/assets/img/icon11.png") },
        { name: "产品设计研发", iconsrc: require("@/assets/img/icon12.png") }
      ],
      Partners: [
        // { id: 1, Partnersrc: require("@/assets/img/logo1.png") },
        // { id: 2, Partnersrc: require("@/assets/img/logo2.png") },
        { id: 1, Partnersrc: require("@/assets/img/dangxiao.png") },
        { id: 2, Partnersrc: require("@/assets/img/minsheng.png") },
        { id: 3, Partnersrc: require("@/assets/img/haiyang.png") },
        { id: 4, Partnersrc: require("@/assets/img/zgxty.png") },
        // { id: 4, Partnersrc: require("@/assets/img/logo4.png") },
        { id: 5, Partnersrc: require("@/assets/img/gjht.png") },
        { id: 6, Partnersrc: require("@/assets/img/logo13.png") },
        { id: 7, Partnersrc: require("@/assets/img/logo6.png") },
        // { id: 7, Partnersrc: require("@/assets/img/logo7.png") },
        // { id: 8, Partnersrc: require("@/assets/img/logo8.png") },
        { id: 8, Partnersrc: require("@/assets/img/nannan.png") },
        { id: 9, Partnersrc: require("@/assets/img/zhongguowang.png") },
        { id: 10, Partnersrc: require("@/assets/img/logo9.png") },
        // { id: 10, Partnersrc: require("@/assets/img/logo10.png") },
        // { id: 11, Partnersrc: require("@/assets/img/logo11.png") },
        { id: 11, Partnersrc: require("@/assets/img/wenlian.png") },

        { id: 12, Partnersrc: require("@/assets/img/zxjt.png") }
      ]
    };
  },
  methods: {
    async getTotal() {
      let param = {
        safecode: "slgapicode"
      };
      var that = this;
      await axios
        .fetchPost("/cooperation/lists", param)
        .then(function(logolist) {});
    },
    bigNext() {
      this.tag++;
      if (this.tag == 4) {
        this.tag = 1;
      }
    },
    bigPrev() {
      if (this.tag == 1) {
        this.tag = 4;
      }
      this.tag--;
    },
    subigNext() {
      this.tag++;
      if (this.tag == 3) {
        this.tag = 1;
      }
    },
    subigPrev() {
      if (this.tag == 1) {
        this.tag = 3;
      }
      this.tag--;
    },
    smallNext() {
      this.index++;
      console.log(this.index);
      if (this.index == 2) {
        this.index = 0;
      }
    },
    smallPrev() {
      this.index--;
      if (this.index == -1) {
        this.index = 1;
      }
    },
    handleClick() {},
    imgHandler(e) {
      //每一个事件都有一个event对象, 冒泡阻止默认事件学的
      console.log(e.target); //当前目标对象 <img src="img/1.jpg" alt>
      console.log(this); //实例化里面的对象this 指的都是当前实例化对象
    }
  },
  mounted() {
    this.getTotal();
    // this.scroll();
    // document.body.addEventListener("scroll", this.showIcon, true);
  }
};
</script>
<style lang="less">
.el-tabs__item {
  color: #a0b1fc !important;
  height: 90px !important;
  line-height: 90px !important;
}
.el-tabs__item:hover {
  color: white !important;
}
.is-active {
  color: white !important;
  font-size: 18px;
}
.el-tabs__active-bar {
  background-color: white !important;
}
.el-tabs__nav-wrap::after {
  background-color: #4d7df5 !important;
  height: 0.5px;
}
.el-tabs__content {
  margin-top: -15px !important;
}
</style>

<style lang="less" scoped>
.container {
  width: 100%;
  background-color: #2445a6;
  .iconbtn {
    position: fixed;
    top: 500px;
    right: 40px;
  }
  .banner {
    margin: auto;
  }
  .AboutUs {
    width: 100%;
    padding-bottom: 76px;
    background-color: #243e9f;
    .abBox {
      width: 1200px;
      margin: auto;
      position: relative;
      .btn-box-bg {
        position: absolute;
        bottom: 10px;
        left: 640px;
        button {
          border: none;
          background: #243e9f;
          border: #4d7df5 2px solid;
          padding: 0px;
          color: white;
          width: 60px;
          height: 60px;
          line-height: 60px;
          font-size: 24px;
          cursor: pointer;
        }
        button:hover {
          border: #ff4e00 2px solid;
          background: #ff4e00;
        }
      }
      .Indicator {
        position: absolute;
        right: 40px;
        bottom: 10px;
        color: #c8d4ff;
        font-size: 16px;
        font-family: DINAlternate-Bold;
        font-weight: bold;
        span {
          margin-left: 30px;
          cursor: pointer;
        }
        .activespan {
          color: white;
          font-size: 22px;
        }
      }
      .title {
        display: flex;
        align-items: center;
        width: 1200px;
        h1 {
          color: white;
          font-size: 36px;
          font-family: SourceHanSansCN-Bold;
          font-weight: bold;
          letter-spacing: 5px;
        }
        img {
          width: 46px;
          height: 41px;
          margin-left: auto;
        }
      }
      .OuterBanner {
        display: flex;
        align-items: center;
        .img-box {
          margin-top: 20px;
          width: 580px;
          height: 490px;
          margin-right: 60px;
          position: relative;
          .btn-box {
            position: absolute;
            bottom: 0px;
            left: 0px;
            button {
              background: #2445a6;
              border: none;
              color: white;
              width: 65px;
              height: 70px;
              margin: 0px;
              padding: 0px;
              font-size: 24px;
              cursor: pointer;
            }
          }
        }
        .beforeBox1::before {
          content: "";
          position: absolute;
          right: 25px;
          top: 105px;
          width: 15px;
          height: 385px;
          background-color: #ff4e00;
        }
        .logoBox {
          display: flex;
          flex-wrap: wrap;
          align-content: flex-start;
          a {
            box-sizing: border-box;
            background-color: #243e9f;
            position: relative;
            height: 130px;
            width: 130px;
            text-align: center;
            box-sizing: border-box;
            padding: 10px 0;
            border: #5c79e0 1px solid;
            margin-right: 10px;
            margin-bottom: 10px;
            img {
              width: 100px;
              height: 100px;
            }
            .icon-p {
              color: #c8d4ff;
              margin: 0;
              font-size: 12px;
              font-weight: normal;
              margin-top: -15px;
            }
          }
          a:hover {
            background-color: #2445a6;
          }
        }
        .Scheme {
          img {
            width: 580px;
          }
        }
        .text-box {
          height: 490px;
          text-align: justify !important;
          h1 {
            font-size: 36px;
            color: white;
            font-family: SourceHanSansCN-Bold;
            letter-spacing: 70;
            line-height: 54px;
            span {
              color: #ff4e00;
            }
          }
          .line {
            width: 71px;
            height: 2px;
            background-color: #ff4e00;
            margin-bottom: 48px;
          }
          .text-conter {
            width: 512px;
            color: #c8d4ff;
            font-family: Adobe Heiti Std R;
            font-size: 16px;
            line-height: 30px;
            letter-spacing: 2px;
          }
          p {
            color: white;
            font-family: Adobe Heiti Std R;
            margin-top: 25px;
          }
        }
      }
    }
  }
  .Service {
    width: 100%;
    background-color: #2445a6;
    padding-bottom: 60px;
    padding-top: 30px;
    .seBox {
      width: 1200px;
      margin: auto;
      .title {
        display: flex;
        align-items: center;
        width: 1200px;
        h1 {
          color: white;
          font-size: 36px;
          font-family: SourceHanSansCN-Bold;
          font-weight: bold;
          letter-spacing: 5px;
        }
        img {
          width: 46px;
          height: 41px;
          margin-left: auto;
        }
      }
    }
    .ads {
      display: flex;
      flex-wrap: wrap;
      width: 1200px;
      .itemBox {
        display: flex;
        width: 600px;
        height: 290px;
        align-items: center;
        border: #4d7df5 1px solid;
        padding-right: 60px;
        box-sizing: border-box;
        .icon-box {
          margin-left: 83px;
          img {
            width: 146px;
            height: 146px;
          }
          p {
            margin-left: 58px;
            color: #f9dd52;
          }
        }
        .text-box {
          text-align: justify !important;
          margin-left: 40px;
          h1 {
            font-size: 26px;
            color: white;
            font-weight: Medium;
            line-height: 48px;
            margin-bottom: 40px;
          }
          p {
            color: #cbe2f3;
            font-size: 15px;
            font-weight: Medium;
            line-height: 31px;
          }
        }
      }
    }
    .bds {
      display: flex;
      flex-wrap: wrap;
      width: 1200px;
      .itemBox {
        width: 240px;
        height: 580px;
        border: #4d7df5 1px solid;
        box-sizing: border-box;
        .icon-box {
          height: 290px;
          text-align: center;
          border-bottom: #4d7df5 1px solid;
          img {
            width: 146px;
            height: 146px;
            margin-top: 68px;
          }
          p {
            color: #f9dd52;
          }
        }
        .text-box {
          text-align: justify !important;
          padding-left: 24px;
          padding-right: 24px;
          height: 290px;
          border-bottom: #4d7df5 1px solid;
          padding-top: 10px;
          box-sizing: border-box;
          h1 {
            font-size: 26px;
            color: white;
            font-weight: Medium;
            line-height: 48px;
            margin-bottom: 20px;
          }
          p {
            color: #cbe2f3;
            font-size: 15px;
            font-weight: Medium;
            line-height: 31px;
          }
        }
      }
    }
    .itemBox:hover {
      background-color: #243e9f;
    }
  }
  .superCase {
    width: 100%;
    background-color: #243e9f;
    padding-bottom: 60px;
    padding-top: 30px;
    .suBox {
      width: 1200px;
      margin: auto;
      position: relative;
      .next {
        width: 150px;
        height: 60px;
        color: white;
        font-size: 28px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        position: absolute;
        bottom: 0px;
        left: 0px;
        div {
          margin-left: 10px;
          text-align: center;
          width: 60px;
          line-height: 60px;
          background-color: #243e9f;
          border: 2px solid rgba(77, 125, 245, 1);
        }
        div:hover {
          background-color: #ff4e00;
          border: 2px solid #ff4e00;
          cursor: pointer;
        }
      }
      .Indicatortwo {
        position: absolute;
        top: 160px;
        left: 0;
        span {
          margin-right: 10px;
          color: #c8d4ff;
          font-family: DINAlternate-Bold;
          font-weight: bold;
          cursor: pointer;
        }
      }
      .activespantwo {
        color: white !important;
        font-size: 22px;
      }
      .title {
        display: flex;
        align-items: center;
        width: 1200px;
        h1 {
          color: white;
          font-size: 36px;
          font-family: SourceHanSansCN-Bold;
          font-weight: bold;
          letter-spacing: 5px;
        }
        img {
          width: 46px;
          height: 41px;
          margin-left: auto;
        }
      }
      .su-banner {
        width: 1200px;
        .item-banner {
          width: 1200px;
          display: flex;
          justify-content: flex-end;
          .imgBox {
            width: 340px;
            height: 520px;
            box-sizing: border-box;
            padding: 30px 32px;
            border: #4a6ed4 1px solid;
            border-top: none;
            border-bottom: none;
            position: relative;
            margin-left: 10px;
            .imgBox-p {
              color: white;
              line-height: 32px;
              font-weight: 500;
              overflow: hidden;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              text-overflow: ellipsis;
              -webkit-line-clamp: 3; /*限制行数为2行*/
              line-clamp: 3; /*限制行数为2行*/
              span {
                color: #5c7ff5;
                font-size: 14px;
                font-family: SourceHanSansCN-Medium;
                margin-right: 10px;
                font-family: Source Han Sans CN;
                font-weight: bold;
              }
            }
            .psis {
              overflow: hidden;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              text-overflow: ellipsis;
              -webkit-line-clamp: 3; /*限制行数为2行*/
              line-clamp: 3; /*限制行数为2行*/
            }
            > img {
              max-width: 215px;
              margin-bottom: 35px;
              height: 49px;
            }
            p:nth-child(3) {
              height: 96.8px;
            }
            .btnBox {
              text-align: center;
              width: 50px;
              height: 50px;
              background-image: url(../assets/img/right1.png);
              background-repeat: no-repeat;
              background-position: 50% 50%;
              align-items: center;
              border-radius: 50px;
              box-sizing: border-box;
              border: #5b7ffb 2px solid;
              cursor: pointer;
              p {
                display: none;
                font-weight: Medium;
                font-size: 14px;
                line-height: 50px;
                height: 50px;
              }
            }
            .poBox {
              display: none;
              width: 690px;
              height: 520px;
              box-sizing: border-box;
              position: absolute;
              top: 0;
              // left: 350px;
              background-color: #2445a6;
              border: #4a6ed4 1px solid;
              z-index: 2000;
              padding: 28px 40px 40px 40px;
              text-align: justify !important;
              img {
                max-width: 215px;
              }
              .poBox-p {
                color: white;
                line-height: 32px;
                font-weight: bold;
                span {
                  color: #5c7ff5;
                  font-size: 14px;
                  font-family: SourceHanSansCN-Medium;
                  margin-right: 10px;
                  font-family: Source Han Sans CN;
                  font-weight: bold;
                }
              }
              > img {
                margin-bottom: 35px;
                height: 49px;
              }
              // p:nth-child(3) {
              //   // margin-bottom: 35px;
              // }
            }
          }
          .imgBox::before {
            content: "";
            position: absolute;
            left: 0px;
            top: 0px;
            width: 3px;
            height: 180px;
            background-color: #5b7ffb;
          }
          .imgBox:hover {
            background-image: url(../assets/img/red.png);
            background-repeat: no-repeat;
            background-size: 100% 100%;
            .imgBox-p {
              span {
                color: #ffff65;
              }
            }
            .poBox {
              display: block;
            }
            .btnBox {
              width: 168px;
              background-color: white;
              border: none;
              background-image: url(../assets/img/rightred.png);
              background-position: 20px 50%;
              text-align: center;
              p {
                display: block;
                color: #ff4e00;
              }
            }
          }
        }
      }
    }
  }
  .industry {
    width: 100%;
    background-color: #2445a6;
    padding-bottom: 60px;
    padding-top: 30px;
    margin-bottom: 180px;
    .inBox {
      width: 1200px;
      margin: auto;
      margin-bottom: 20px;
      .title {
        display: flex;
        align-items: center;
        width: 1200px;
        h1 {
          color: white;
          font-size: 36px;
          font-family: SourceHanSansCN-Bold;
          font-weight: bold;
          letter-spacing: 5px;
        }
        img {
          width: 46px;
          height: 41px;
          margin-left: auto;
        }
      }
    }
    .Modul {
      display: flex;
      align-items: center;
      justify-content: center;
      a {
        width: 163px;
        box-sizing: border-box;
        margin-right: 10px;
        text-align: center;
        font-weight: bold;
        font-size: 18px;
        cursor: pointer;
        color: white;
        overflow: hidden;
        div {
          width: 163px;
          height: 163px;
          overflow: hidden;
          img {
            transition: all 0.6s !important;
            height: 163px;
            overflow: hidden;
          }
          img:hover {
            transform: scale(1.2) !important;
          }
        }
      }
      a:hover {
        color: #ff4e00;
      }
      a:nth-child(7) {
        margin-right: 0px !important;
      }
    }
  }
  .Partners {
    width: 100%;
    background-color: #1e388c;
    position: relative;
    height: 510px;
    div {
      width: 1441px;
      display: flex;
      margin: auto;
      background-color: #243e9f;
      justify-content: center;
      flex-wrap: wrap;
      padding: 100px 176px;
      box-sizing: border-box;
      position: absolute;
      top: -180px;
      left: 50%;
      transform: translate(-50%);
      img {
        width: 270px;
        height: 160px;
      }
      a {
        border: #4a6ed4 1px solid;
        position: relative;
        svg {
          position: absolute;
          left: 0px;
          top: 0;
          line {
            stroke-width: 3;
            stroke: #ecf0f1;
            fill: none;
            transition: all 0.8s ease-in-out;
            opacity: 0;
          }
          .top,
          .bottom {
            stroke-dasharray: 300 214;
          }
          .left,
          .right {
            stroke-dasharray: 164 164;
          }
        }
      }
      a:hover {
        // border: white 1px solid;
        transition-delay: 0s;
        line {
          transition-delay: 0.1s;
          opacity: 100;
        }
        line.top {
          transform: translateX(-540px);
        }
        line.bottom {
          transform: translateX(540px);
        }
        line.left {
          transform: translateY(328px);
        }
        line.right {
          transform: translateY(-328px);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue